/**
 * LA PASTILLE D'UN MODULE dans le menu latéral — lot 4 (30/08).
 *
 * Le contrat `ModuleBadge` (module-contract.ts) existait depuis le 14/08 sans
 * un seul consommateur. Ce composant est LE consommateur : le Shell le monte
 * pour chaque module qui déclare un badge.
 *
 * Zéro, null ou erreur → RIEN : une pastille à « 0 » est du bruit permanent,
 * une pastille sur donnée en échec est un mensonge.
 */
import { useQuery } from "@tanstack/react-query";
import type { ModuleBadge } from "./module-contract";

export function NavBadge({ badge }: { badge: ModuleBadge }) {
  const q = useQuery({
    queryKey: badge.queryKey,
    queryFn: badge.queryFn,
    refetchInterval: badge.refetchIntervalMs,
    staleTime: badge.refetchIntervalMs,
  });
  const n = q.data ?? null;
  if (q.isError || n === null || n <= 0) return null;
  return <span className="nav-dot">{n}</span>;
}
